import React from 'react';
import SpeakerHeadshot from '../ui-components/SpeakerHeadshot.jsx';
import { getFormattedSpeakerName } from '../utils/helpers.js';

const SpeakerCard = ({ speakerId, name, title, company, image, onSpeakerClick, salutation, honorific, visibleSpeakerFields = [] }) => {
  const handleClick = () => {
    if (onSpeakerClick && speakerId) {
      onSpeakerClick(speakerId);
    }
  };
  const headshotData = {
    photo: image,
    full_name: name,
  };
  return (
    <div className="speaker-card" onClick={handleClick} style={{ cursor: onSpeakerClick ? 'pointer' : 'default' }}>
      <SpeakerHeadshot speaker={headshotData} />
      <div className="speaker-card__content">
        <h4 className="speaker-card__name">
          {getFormattedSpeakerName(
            visibleSpeakerFields.includes('salutation') ? salutation : '',
            name,
            visibleSpeakerFields.includes('honorific') ? honorific : ''
          )}
        </h4>
        <div className="speaker-card__details">
          <p className="speaker-card__title">{title}</p>
          <p className="speaker-card__company">{company}</p>
        </div>
      </div>
    </div>
  );
};

export default SpeakerCard;
